"use strict";

const template = document.createElement('template');
template.setAttribute('shadowrootclonable', 'shadowrootclonable');
template.innerHTML = /*html*/ `
  <style>  
  button {
    font: inherit;
    color: inherit;
    appearance: none;
    padding: 0px;
    border: none;
    background: transparent;
    cursor: pointer;
  }
  input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #000;
  }
  a {
    text-decoration: underline;
    color: inherit;
  }
  .size-chart__dialog {
    max-width: 600px;
    width: 90vw;
    border: none;
    padding: 0px;
    background-color: #FFFFFF;
    box-shadow: 4px 4px 15.8px 0 rgba(0, 0, 0, 0.20);
  }
  .size-chart__dialog::backdrop {
    background-color: rgba(30, 30, 30, 0.20);
  }
  .size-chart__heading-bar{
    padding: 11px 21px;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 5.56px;
    background-color: #F4F3F2;
    font-size: 12px;
    line-height: 12.7px;
  }
  @media (min-width: 720px){
    .size-chart__heading-bar{
      padding: 19px 35.56px;
      font-size: 13px;
      line-height: 22px;
    }
  }
  .size-chart__title{
    font-family: var(--font-heading);
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    line-height: 22px;
    margin: 0px;
    letter-spacing: 0.667px;
  }
  .size-chart__desktop-label{
    display: none;
  }
  @media (min-width: 720px){
    .size-chart__desktop-label{
      display: inline;
    }
  }
  .size-chart__units{
    display: flex;
    flex-direction: row;
    gap: 18.67px;
    align-items: center;
  }
  @media (min-width: 720px){
    .size-chart__units{
      gap: 31px;
    }
  }
  .size-chart__unit-label{
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    line-height: 16px;
  }
  .size-chart__body{
    margin-block: 10px;
    margin-inline: 18px;
  }
  @media (min-width: 720px){
    .size-chart__body{
    margin-block-start: 25px;
    margin-block-end: 10px;
    margin-inline: 30px;
  }
  }
  :is(.size-chart__unit-selector, .size-chart__unit-selector--open){
    position: relative;
    white-space: nowrap;
    display: inline-block;
  }
  .size-chart__unit-selected-option{
    font-size: 13px;
    cursor: pointer;
    line-height: 22px;
    font-weight: bold;
  }
  .size-chart__unit-dropdown {
    display: inline-block;
    width: 22px;
    height: 22px;
    vertical-align: top;
    object-fit: contain;
  }
  .size-chart__unit-options{
    visibility: hidden;
    position: absolute;
    background-color: #FFF;
    text-align: left;
    font-size: 13px;
    display: inline-flex;
    flex-direction: column;
    gap: 0px;
    left: 0px;
    align-items: flex-start;
    margin-block: 0px;
    border: 1px solid rgba(0, 0, 0, 0.10);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.10);
    font-weight: 300;
  }
  .size-chart__unit-selector--open .size-chart__unit-dropdown {
    transform: rotate(0.5turn);
  }
  .size-chart__unit-selector--open .size-chart__unit-options {
    visibility: visible;
  }

  .size-chart__unit-option{
    padding: 7px;
    text-align: left;
    min-width: 10em;
    outline: none;
  }
  .size-chart__unit-option:hover{
    background-color: rgba(0, 0, 0, 0.025);
  }
  .size-chart__unit-option:focus{
    background-color: rgba(0, 0, 0, 0.04);
  }

  .size-chart__table{
    border-collapse: collapse;
    font-size: 13px;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }
  .size-chart__table tr{
    border-top: 1px solid rgba(0, 0, 0, 0.10);
  }
  .size-chart__table tr:first-child{
    border-top: none;
  }
  .size-chart__table :is(td, th){
    padding-block: 12px;
  }
  @media (min-width: 720px){
    .size-chart__table :is(td, th){
      padding-block: 13.25px;
    }
  }
  .size-chart__unit-label:has(:checked){
    font-weight: bold;
  }
  input[type="radio"].size-chart__radio-input{
    margin: 0px;
    width: 13px;
    height: 13px;
    vertical-align: middle;
  }
  @media (min-width: 720px){
    input[type="radio"].size-chart__radio-input{
      width: 16px;
      height: 16px;
    }
  }
  .size-chart__close{
    width: 15px;
    height: 15px;
  }
  @media (min-width: 720px){
    .size-chart__close{
    width: 13.6px;
    height: 13.6px;
  }
  }
  .size-chart__close .icon{
    width: 100%;
    height: 100%;
  }
  .size-chart__close .icon svg{
    width: 100%;
    height: 100%;
  }
  .size-chart__footer{
    padding: 8.5px 18px;
    background-color: #F4F3F2;
    line-height: 13.33px;
    font-size: 10px;
    text-align: center;
  }
  @media (min-width: 720px){
    .size-chart__footer{
      padding: 17.5px 27px;
      font-size: 13px;
    }
  }
  .size-chart__footer :is(p, h1, h2, h3, h4, h5, h6, div, blockquote, ul, li){
    display: block;
    margin: 0px;
    font: inherit;
    list-style: none;
    padding: 0px;
  }
  .size-chart__footer strong{
    font-weight: bold;
  }
  .size-chart__footer a[href]{
    text-decoration: underline;
  }
  .size-chart__opener {
    display: inline-flex;
    font-size: 13px;
    gap: 0.5em;
    margin-block-end: 1.3em;
    align-items: center;
    text-decoration: underline;
  }
  .size-chart__opener-icon {
    width: 19px;
  }
  </style>
  <div>
    <button type="button" class="size-chart__opener">
      <svg
        class="size-chart__opener-icon"
        width="15.998064"
        height="9.8755989"
        viewBox="0 0 4.232821 2.6129189"
        ><defs
          id="defs1" /><g
          id="layer1"
          transform="translate(-96.042969,-148.82804)"><path
            style="baseline-shift:baseline;display:inline;overflow:visible;opacity:1;vector-effect:none;stroke-width:1;paint-order:markers fill stroke;enable-background:accumulate;stop-color:#000000;stop-opacity:1"
            d="m 97.486372,148.82804 c -0.430843,0 -0.78118,0.35033 -0.78118,0.78118 0,0.2187 0.0908,0.41606 0.236046,0.55798 h -0.898269 v 1.27217 h 3.271686 l -0.0085,-2.3e-4 c 0,0 0.231998,0.0195 0.470883,-0.0692 0.119442,-0.0444 0.244222,-0.11764 0.338862,-0.23824 0.0946,-0.12059 0.15457,-0.28696 0.15289,-0.4968 -0.005,-0.67724 -9.4e-4,-0.8939 0,-0.95188 0.002,-0.0247 0.007,-0.0485 0.007,-0.0738 0,-0.43084 -0.350337,-0.78118 -0.781181,-0.78118 z m 0,0.22319 h 2.008749 c 0.297715,0 0.530569,0.2284 0.550519,0.52053 0,1.1e-4 5e-5,0.0717 0,0.0749 -0.02,0.29213 -0.252804,0.52053 -0.550519,0.52053 H 98.17353 97.486372 c -0.311054,0 -0.557985,-0.24693 -0.557985,-0.55798 0,-0.31106 0.246931,-0.55799 0.557985,-0.55799 z m 0,0.44639 v 0.22319 h 2.008749 v -0.22319 z m 2.559268,0.66508 c -5.1e-4,0.17197 -0.003,0.13791 0,0.47396 10e-4,0.16811 -0.0426,0.27729 -0.105338,0.35731 -0.06279,0.08 -0.149021,0.13258 -0.240989,0.16673 -0.0145,0.005 -0.02603,0.004 -0.04053,0.008 v -0.44397 h -0.223195 v 0.48912 c -0.06469,0.004 -0.112585,0.002 -0.112585,0.002 l -0.0042,-3.3e-4 h -0.307332 v -0.26032 h -0.223194 v 0.26032 h -0.424091 v -0.49099 h -0.223195 v 0.49099 H 97.7169 v -0.26032 h -0.223194 v 0.26032 h -0.423981 v -0.49099 H 96.84653 v 0.49099 h -0.580393 v -0.82578 h 1.220209 0.687158 1.321591 c 0.214665,0 0.409198,-0.0871 0.550515,-0.2277 z"
            id="path3-2-6" /></g></svg>
      Size Guide
    </button>

    <dialog class="size-chart__dialog">
      <div class="size-chart__dialog-contents">
        <div class="size-chart__heading-bar">
          <h5 class="size-chart__title">
            <span class="size-chart__desktop-label">Size Guide: </span><span data-ref="title"></span>
          </h5>

          <div class="size-chart__units">
            <label class="size-chart__unit-label">
              <input value="in" type="radio" class="size-chart__radio-input" name="sizechart_units"> Inches
            </label>
            <label class="size-chart__unit-label">
              <input value="cm" type="radio" class="size-chart__radio-input" name="sizechart_units"> Centimeters
            </label>
          </div>

          <button type="button" class="size-chart__close">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.66 1.34 2 .68.68 2l.66.66 1.32-1.32zm18.68 21.32.66.66L23.32 22l-.66-.66-1.32 1.32zm1.32-20 .66-.66L22 .68l-.66.66 1.32 1.32zM1.34 21.34.68 22 2 23.32l.66-.66-1.32-1.32zm0-18.68 10 10 1.32-1.32-10-10-1.32 1.32zm11.32 10 10-10-1.32-1.32-10 10 1.32 1.32zm-1.32-1.32-10 10 1.32 1.32 10-10-1.32-1.32zm0 1.32 10 10 1.32-1.32-10-10-1.32 1.32z"
                fill="currentColor"/>
            </svg>
          </button>
        </div>

        <div class="size-chart__body">
          <div class="size-chart__unit-selector" aria-expanded="false" role="combobox" aria-activedescendant tabindex="0" style="display: none">
            <div class="size-chart__unit-selected-option">
              <span data-ref="selected-label"></span>
              <svg
                aria-hidden="true"
                fill="none"
                viewBox="-8 -8 32 32"
                role="presentation"
                class="size-chart__unit-dropdown">
                <path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"></path>
              </svg>
            </div>
            <div class="size-chart__unit-options" role="listbox">
              <button aria-selected="false" role="option" class="size-chart__unit-option" type="button" data-ref="alpha-size-button">Alpha</button>
              <button aria-selected="false" role="option" class="size-chart__unit-option" type="button" data-ref="numerical-size-button">Numerical</button>
            </div>
          </div>
          <table class="size-chart__table"></table>
        </div>
        <div class="size-chart__footer"></div>
      </div>
    </dialog>
</div>`;

export default class SizeChart extends HTMLElement {
  #fullConfig = null;
  #productType = null;
  #openerButton = null;
  #closeButton = null;
  #dialog = null;

  #currentChart = null;
  #table = null;
  #unitCheckboxes = null;
  #sizeTypeSelector = null;
  #numericalSizeButton = null;
  #sizeTypeSelectedOption = null;
  #sizeTypeSelectedLabel = null;
  #sizeTypeOptions = null;
  #alphaSizeButton = null;
  #sizeType = null;
  #displayTitle = null;
  #footer = null;
  #sizeLabel = null;
  static #indexForIds = 0;

  #shadowDOM = null;

  #htmlEscape(string) {
    return String(string)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  constructor() {
    super();

    const contents = template.content.cloneNode(true);
    template.content.cloneNode(true);

    this.#shadowDOM = this.attachShadow({ mode: 'open' });
    this.#shadowDOM.append(contents);

    SizeChart.#indexForIds++;
    
  }

  connectedCallback() {
    this.#table = this.#shadowDOM.querySelector('.size-chart__table');
    this.#unitCheckboxes = this.#shadowDOM.querySelectorAll('input[name="sizechart_units"]');

    this.#openerButton = this.#shadowDOM.querySelector('.size-chart__opener');
    this.#dialog = this.#shadowDOM.querySelector('.size-chart__dialog');
    this.#closeButton = this.#shadowDOM.querySelector('.size-chart__close');
    this.#sizeTypeSelector = this.#shadowDOM.querySelector('.size-chart__unit-selector');
    this.#numericalSizeButton = this.#shadowDOM.querySelector('[data-ref="numerical-size-button"]');
    this.#sizeTypeSelectedOption = this.#shadowDOM.querySelector('.size-chart__unit-selected-option');
    this.#sizeTypeSelectedLabel = this.#shadowDOM.querySelector('[data-ref="selected-label"]');
    this.#sizeTypeOptions = this.#shadowDOM.querySelector('.size-chart__unit-options');
    this.#alphaSizeButton = this.#shadowDOM.querySelector('[data-ref="alpha-size-button"]');
    this.#displayTitle = this.#shadowDOM.querySelector('[data-ref="title"]');
    this.#footer = this.#shadowDOM.querySelector('.size-chart__footer');
    this.#sizeLabel = document.createElement('span');

    this.#productType = this.getAttribute('product-type');
    try {
      this.#fullConfig = JSON.parse(this.getAttribute('full-config'));
    } catch (e) {
      this.#handleError(e);
      return;
    }


    const overrideChart = this.getAttribute('override-chart');
    if (overrideChart) {
      try {
        this.#currentChart = JSON.parse(overrideChart);
      } catch (e) {
        this.#handleError(e);
        return;
      }
    } else {

      const chartName = this.#fullConfig.product_type_mappings[this.#productType];

      if (chartName) {
        this.#currentChart = this.#fullConfig.size_charts[chartName];
      }
    }


    if (!this.#currentChart) {
      this.#openerButton.style.display = 'none';
      return;
    } else {
      this.#openerButton.style.display = '';
    }

    this.#displayTitle.textContent = this.#currentChart.name;

    
    this.#applyDefaultValues();
    this.#attachEvents();
    this.#createTable();
    this.#updateFooter();
  }

  #applyDefaultValues() {
    if (
      this.#currentChart.numerical_sizes &&
      this.#currentChart.alpha_sizes
    ) {

      if (this.getAttribute('size-type') === 'Alpha') {
        this.#sizeType = 'alpha';
      } else {
        this.#sizeType = 'numerical';
      }

      this.#sizeTypeSelectedLabel.textContent = this.#sizeTypeOptions.querySelector(`button[data-ref="${this.#sizeType}-size-button"]`).textContent;
    } else {
      this.#sizeTypeSelector.style.display = 'none';
    }

    let defaultUnitCheckbox = this.#unitCheckboxes[0];

    if (defaultUnitCheckbox) {
      defaultUnitCheckbox.checked = true;
    }

    this.#sizeTypeSelectedLabel.setAttribute('id', `sizechart-label-${SizeChart.#indexForIds}`);
    this.#sizeTypeOptions.setAttribute('id', `sizechart-options-${SizeChart.#indexForIds}`);

    this.#numericalSizeButton.setAttribute('id', `sizechart-option-numerical-${SizeChart.#indexForIds}`);
    this.#alphaSizeButton.setAttribute('id', `sizechart-option-alpha-${SizeChart.#indexForIds}`);
    
    this.#sizeTypeSelector.setAttribute('aria-haspopup', `listbox`);
    this.#sizeTypeSelector.setAttribute('aria-labelledby', `sizechart-label-${SizeChart.#indexForIds}`);
    this.#sizeTypeSelector.setAttribute('aria-controls', `sizechart-options-${SizeChart.#indexForIds}`);
    
    this.#sizeTypeOptions.setAttribute('aria-labelledby', `sizechart-label-${SizeChart.#indexForIds}`);
    this.#sizeTypeOptions.querySelector(`button[data-ref="${this.#sizeType}-size-button"]`)?.setAttribute('aria-selected', 'true');

    this.#sizeLabel.textContent = this.#currentChart.size_label ?? 'Size';
  }
  #attachEvents() {
    this.#openerButton.addEventListener('click', () => this.#dialog.showModal());
    this.#closeButton.addEventListener('click', () => this.#dialog.close());

    for (const checkbox of this.#unitCheckboxes) {
      checkbox.addEventListener('change', () => this.#updateTable());
    }

    this.#attachDropDownEvents();

    this.#dialog.addEventListener('click', (event) => {
      const clickInsideModal = event.target.closest('.size-chart__dialog-contents');

      if (!clickInsideModal) {
        this.#dialog.close()
      }
    });
  }

  #attachDropDownEvents() {
    if (this.#currentChart.numerical_sizes && this.#currentChart.alpha_sizes) {
      this.#sizeTypeSelectedOption.addEventListener('click', () => {
        if (this.#sizeTypeSelector.classList.contains('size-chart__unit-selector--open')) {
          this.#closeSizeTypeDropdown();
        }
        else {
          this.#openSizeTypeDropdown();
        }
      });
      this.#numericalSizeButton.addEventListener('click', () => this.#toggleSizeType('numerical'));
      this.#alphaSizeButton.addEventListener('click', () => this.#toggleSizeType('alpha'));
      this.#sizeTypeSelector.addEventListener('keydown', (event) => {
        const isOpen = this.#sizeTypeSelector.classList.contains('size-chart__unit-selector--open');

        if (isOpen) {
          const firstButton = this.#sizeTypeOptions.querySelector('button');
          const focusedButton = this.#sizeTypeOptions.querySelector('button:focus');

          switch (event.key) {
            case 'Escape':
              event.preventDefault();
              this.#closeSizeTypeDropdown();
              break;

            case 'ArrowDown':
              event.preventDefault();

              const nextButton = focusedButton.nextElementSibling;

              if (!focusedButton) {
                firstButton.focus();
              }
              if (nextButton) {
                nextButton.focus();
              }
              break;
            case 'ArrowUp':

              event.preventDefault();
              const prevButton = focusedButton.previousElementSibling;

              if (!focusedButton) {
                firstButton.focus();
              }
              if (prevButton) {
                prevButton.focus();
              }

              break;
          }
        } else {
          if ([' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
            event.preventDefault();
            this.#openSizeTypeDropdown();
          }
        }
      });
      this.#sizeTypeSelector.addEventListener('focusout', (event) => {
        const isFocusInSizeTypeSelector = event.relatedTarget && (
          event.relatedTarget === this.#sizeTypeSelector ||
          event.relatedTarget?.closest('.size-chart__unit-selector')
        );
        if (!isFocusInSizeTypeSelector) {
          this.#closeSizeTypeDropdown();
        }
      });
    }

    const onSizeFocus = (event) => {
      const sizeOption = event.target;
      this.#sizeTypeSelector.setAttribute('aria-activedescendant', sizeOption.id);
    };

    this.#alphaSizeButton.addEventListener('focus', onSizeFocus);
    this.#numericalSizeButton.addEventListener('focus', onSizeFocus);
  }

  #toggleSizeType(newSizeType) {
    this.#sizeType = newSizeType;

    if (newSizeType === 'numerical') {
      this.#sizeTypeSelectedLabel.textContent = this.#numericalSizeButton.textContent;
      this.#alphaSizeButton.setAttribute('aria-selected', 'false');
      this.#numericalSizeButton.setAttribute('aria-selected', 'true');
    } else {
      this.#sizeTypeSelectedLabel.textContent = this.#alphaSizeButton.textContent;
      this.#alphaSizeButton.setAttribute('aria-selected', 'true');
      this.#numericalSizeButton.setAttribute('aria-selected', 'false');
    }
    this.#closeSizeTypeDropdown();
    this.#updateTable();
  }
  #openSizeTypeDropdown() {
    this.#sizeTypeSelector.classList.add('size-chart__unit-selector--open');
    this.#sizeTypeSelector.setAttribute('aria-expanded', 'true');
    this.#sizeTypeOptions.querySelector(`button[data-ref="${this.#sizeType}-size-button"]`).focus();
  }
  #closeSizeTypeDropdown() {
    this.#sizeTypeSelector.classList.remove('size-chart__unit-selector--open');
    this.#sizeTypeSelector.setAttribute('aria-expanded', 'false');
    this.#sizeTypeSelector.setAttribute('aria-activedescendant', '');
    this.#sizeTypeSelector.focus();
  }

  #updateTable() {
    try {
      return this.#updateTableRaw();
    } catch (e) {
      this.#handleError(e);
      return;
    }
  }

  #createTable()
  {
    let tableContents = '';

    const measurements = this.#currentChart.measurements;

    // Display headers
    const tableHeaders = [null, ...measurements].map((measurement) => {
      return `<th>${this.#htmlEscape(measurement?.label ?? '')}</th>`;
    });

    tableContents = `<tr data-ref="header">${tableHeaders.join('')}</tr>`;

    this.#table.innerHTML = tableContents;
    this.#sizeTypeSelector.style.display = '';
    this.#table.querySelector('th').append(this.#sizeLabel);
    this.#table.querySelector('th').append(this.#sizeTypeSelector);

    this.#updateTable();
  }

  #updateTableRaw() {
    const unit = this.#shadowDOM.querySelector('input[name="sizechart_units"]:checked').value;

    const tableRows = [];

    const measurements = this.#currentChart.measurements;
    const measurementsKeys = measurements.map((measurement) => measurement.key);

    let currentSizes = [];

    if (
      this.#currentChart.numerical_sizes &&
      this.#currentChart.alpha_sizes
    ) {
      this.#sizeTypeSelector.style.display = '';
      this.#sizeLabel.style.display = 'none';

      if (this.#sizeType === 'alpha') {
        currentSizes = this.#currentChart.alpha_sizes;
      } else {
        currentSizes = this.#currentChart.numerical_sizes;
      }
    } else {
      this.#sizeTypeSelector.style.display = 'none';
      this.#sizeLabel.style.display = '';

      if (this.#currentChart.numerical_sizes) {
        currentSizes = this.#currentChart.numerical_sizes;
      } else if (this.#currentChart.alpha_sizes) {
        currentSizes = this.#currentChart.alpha_sizes;
      }
    }

    for (const currentSize of currentSizes) {
      let rowHTML = `<th scope="row">${this.#htmlEscape(currentSize.size)}</th>`;

      for (const measurementKey of measurementsKeys) {
        const measurementKeyConfig = measurements.find(
          (m) => m.key === measurementKey
        );

        let value = '.';

        switch (measurementKeyConfig.type) {
          case 'size':
            value = currentSize.values[measurementKey];
            break;
          case 'measurement':
            let inValues = currentSize.values[measurementKey].in ?? null;
            let cmValues = currentSize.values[measurementKey].cm ?? null;

            if (inValues && !cmValues) {
              cmValues = inValues.map((inValue) => {
                let output = inValue * this.#fullConfig.unit_conversions.cm_multiplier;
                output = Math.round(output);

                return output;
              });
            }
            if (cmValues && !inValues) {
              inValues = cmValues.map((cmValue) => {
                let output = cmValue / this.#fullConfig.unit_conversions.cm_multiplier;
                output = Math.round(output);

                return output;
              });
            }

            if (unit == 'cm' && cmValues) {
              value = cmValues.join('-');
            } else if (inValues) {
              value = inValues.join('-');
            } else {
              value = '';
            }

            break;
        }

        rowHTML += `<td>${this.#htmlEscape(value)}</td>`;
      }

      const row = document.createElement('tr');
      row.innerHTML = rowHTML;

      tableRows.push(row);
    }

    this.#table.querySelectorAll('tr').forEach((tr) => {
      if (tr.getAttribute('data-ref') !== 'header') {
        tr.remove();
      }
    });
    this.#table.append(...tableRows);
    

    // this.#table.innerHTML = tableContents;

  }
  #updateFooter() {
    const footer = this.getAttribute('footer');
    if (footer) {
      this.#footer.style.display = '';
      this.#footer.innerHTML = footer;
    } else {
      this.#footer.style.display = 'none';
    }
  }
  #handleError(exception) {
    console.error("{{Size chart Error}}", exception);
    this.#openerButton.style.display = 'none';
    return;
  }
}
